/* ============================================================
   CARRITO — CONTADOR DE LA CABECERA + CESTA VACIA
   Medidas copiadas de gudslip.com (1 sep 2026)

   Hace dos cosas:
     1. Mantiene la variable `--pn-unidades` en `#cart-drawer`, que es de
        donde el CSS saca el "· 2" del titulo. Ver `pn-contador-cesta.css`.
     2. El estado VACIO: tres fotos de coleccion y una fila de recomendados.

   Los datos del estado vacio los emite `snippets/pn-cesta-vacia.liquid` en
   window.__PN_CESTA. Las medidas estan en `pn-cesta-vacia.css` y el tamano
   del panel y la cabecera en `pn-carrito-ancho.css`.

   🚩 EL CONTADOR NO ES UN ELEMENTO. Se intento dos veces con DOM y las dos
   fallaron: reescribir el titulo destruia el texto oculto para lectores de
   pantalla que mete el tema, y anadirle un <span> parpadeaba porque el cajon
   se repinta y se lo llevaba por delante (medido: desaparecia 3 veces en 6
   segundos). Ahora solo se escribe una VARIABLE CSS en `#cart-drawer`, que
   es el <theme-drawer> de theme.liquid y NO se repinta — lo que se repinta es
   la seccion de dentro. Un repintado ya no puede borrar el numero porque no
   hay ningun nodo que borrar.

   ⚠️ EL VALOR VA ENTRECOMILLADO (`"2"`): `content` concatena cadenas. Sin las
   comillas la regla es invalida y no se pinta nada.

   🚩 LAS UNIDADES SE SACAN DE `input[name="updates[]"]`, uno por linea y con
   la cantidad como valor. Sumarlos NO cuesta ni una peticion.

   ⚠️ ESCRIBIR EN EL CAJON DISPARA EL MutationObserver DE ESTE MISMO FICHERO.
   Por eso el bloque vacio lleva la marca `data-pn-cesta` y las mutaciones del
   reloj de la reserva se ignoran (ver `IGNORAR`). El fallo de fondo por el
   que el reloj repintaba el carrito entero cada segundo esta arreglado en
   `pn-carrito-total.js`.

   ⚠️ SE OCULTA `cart-items-component` EN EL ESTADO VACIO. Ahi viven el titulo
   centrado "Cesta", el aviso de "¿Tienes una cuenta?" y el boton "Seguir
   comprando". La referencia no tiene nada de eso y el usuario lo pidio. Solo
   se oculta CUANDO ESTA VACIO: el selector cuelga de `.cart-drawer--empty`.

   ⚠️ EL TITULO DEL ESTADO VACIO SE METE DENTRO DE `.theme-drawer__header`,
   que es donde vive la X, para que compartan fila. Fuera quedan en dos lineas.

   ⚠️ EL BOTON "+" NO LLEVA AJAX PROPIO. Pinta un <form action="/cart/add"> y
   `assets/pn-carrito.js` YA intercepta esa accion. Con mas de una variante no
   anade: lleva a la ficha, porque no se puede adivinar la talla.
   ============================================================ */
(function () {
  'use strict';

  /* Lo que se reescribe solo dentro del cajon (el reloj de la reserva) y no
     debe disparar trabajo. */
  var IGNORAR = '.pnr-reserva';

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function unidades() {
    var qs = document.querySelectorAll('#cart-drawer input[name="updates[]"]');
    var n = 0;
    for (var i = 0; i < qs.length; i++) { n += parseInt(qs[i].value, 10) || 0; }
    return n;
  }

  /* Solo una variable CSS sobre un elemento que no se repinta. Ver arriba. */
  function pintarContador() {
    var caj = document.querySelector('#cart-drawer');
    if (!caj) { return; }
    var v = '"' + unidades() + '"';
    if (caj.style.getPropertyValue('--pn-unidades') !== v) {
      caj.style.setProperty('--pn-unidades', v);
    }
  }

  function tarjetaColeccion(c) {
    return '<a class="pn-cesta__col" href="' + esc(c.url) + '">' +
             '<img class="pn-cesta__col-img" src="' + esc(c.img) + '" alt="' + esc(c.titulo) + '" loading="lazy" decoding="async">' +
             '<span class="pn-cesta__col-nombre">' + esc(c.titulo) + '</span>' +
           '</a>';
  }

  function tarjetaProducto(p) {
    var accion;
    if (p.variantes === 1 && p.vid) {
      accion = '<form class="pn-cesta__add" action="/cart/add" method="post">' +
                 '<input type="hidden" name="id" value="' + esc(p.vid) + '">' +
                 '<button class="pn-cesta__mas" type="submit" name="add" aria-label="Añadir">+</button>' +
               '</form>';
    } else {
      accion = '<a class="pn-cesta__mas" href="' + esc(p.url) + '" aria-label="Ver la prenda">+</a>';
    }
    return '<div class="pn-cesta__prod">' +
             '<a class="pn-cesta__prod-foto" href="' + esc(p.url) + '">' +
               '<img src="' + esc(p.img) + '" alt="' + esc(p.titulo) + '" loading="lazy" decoding="async">' +
             '</a>' +
             '<div class="pn-cesta__prod-txt">' +
               '<a class="pn-cesta__prod-nombre" href="' + esc(p.url) + '">' + esc(p.titulo) + '</a>' +
               '<span class="pn-cesta__prod-precio">' + esc(p.precio) + '</span>' +
             '</div>' + accion +
           '</div>';
  }

  function pintarVacio() {
    var d = window.__PN_CESTA;
    if (!d) { return; }

    var vacio = document.querySelector('#cart-drawer .cart-drawer--empty');
    if (!vacio) { return; }
    if (vacio.getAttribute('data-pn-cesta') === '1') { return; }

    var cols = d.colecciones || [];
    var prods = d.recomendados || [];
    if (!cols.length && !prods.length) { return; }

    vacio.setAttribute('data-pn-cesta', '1');

    /* 1. El titulo, dentro de la cabecera de la X para compartir fila. */
    var cab = vacio.querySelector('.theme-drawer__header');
    if (cab && !cab.querySelector('.pn-cesta__cab')) {
      var h = document.createElement('h2');
      h.className = 'pn-cesta__cab';
      h.innerHTML = esc((d.textos && d.textos.cesta) || 'Tu cesta') +
                    ' <span class="pn-cesta__contador">· 0</span>';
      cab.insertBefore(h, cab.firstChild);
    }

    /* 2. El cuerpo. */
    var html = '<div class="pn-cesta">';

    if (cols.length) {
      html += '<div class="pn-cesta__cols">';
      for (var i = 0; i < cols.length; i++) { html += tarjetaColeccion(cols[i]); }
      html += '</div>';
    }

    if (prods.length) {
      html += '<p class="pn-cesta__titulo">' + esc((d.textos && d.textos.titulo) || '') + '</p>';
      html += '<div class="pn-cesta__reco">';
      for (var j = 0; j < prods.length && j < 6; j++) { html += tarjetaProducto(prods[j]); }
      html += '</div>';
    }

    html += '</div>';

    var caja = document.createElement('div');
    caja.innerHTML = html;
    vacio.appendChild(caja.firstChild);
  }

  function pintar() {
    pintarVacio();
    pintarContador();
  }

  function relevante(muts) {
    for (var i = 0; i < muts.length; i++) {
      var n = muts[i].target;
      var el = n.nodeType === 1 ? n : n.parentElement;
      if (el && el.closest && el.closest(IGNORAR)) { continue; }
      return true;
    }
    return false;
  }

  function vigilar() {
    var raiz = document.querySelector('#cart-drawer');
    if (!raiz || raiz.dataset.pnCestaVigilado === '1' || !window.MutationObserver) { return; }
    raiz.dataset.pnCestaVigilado = '1';
    var t;
    new MutationObserver(function (muts) {
      if (!relevante(muts)) { return; }
      clearTimeout(t);
      t = setTimeout(pintar, 60);
    }).observe(raiz, { childList: true, subtree: true });
  }

  function iniciar() { pintar(); vigilar(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
  document.addEventListener('shopify:section:load', iniciar);
  setTimeout(iniciar, 800);
  setTimeout(iniciar, 2000);
})();
